import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../state'
import * as content from '../../../content'

/**
 * Platform-level Users page in Admin Center.
 */
@ngCore.Component({
  imports: [
    ds.table.Component,
    ds.layout.page.Component,
    content.admin.modals.user.Component,
    ds.overlay.confirmation.Component,
  ],
  selector: 'atn-admin-users-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.users.Collection} */
  public readonly usersEc = ngCore.inject(state.admin.users.Collection)

  /** Name of the user marked for deletion */
  public deletingUserNameSg = ngCore.computed(
    (
      [deletedUser] = this.usersEc.plugins.editingPlugin.feature.selectors
        .deletedEntities()
        .asSignal(),
    ) => deletedUser?.name,
  )

  /** Text displayed in delete confirmation dialog. */
  public readonly deleteConfirmationTextSg = ngCore.computed(
    (
      deletingUserName = this.deletingUserNameSg(),
    ) => `Are you sure you want to delete <b>
      ${deletingUserName}</b>? The user will be deleted and unassigned from every tenant and entity where they are assigned. This action cannot be undone.
      <br> Please type <b>
      ${deletingUserName}
      </b> in the field below to confirm this action.`,
  )

  /** Canonical table input for platform users. */
  public readonly usersTableConfig = {
    collection: this.usersEc,
    view: {
      creation: true,
      search: true,
      title: 'Users',
    },
  } satisfies ds.table.ec.Config.Input<state.admin.users.TypeParams>

  /**
   * Handles the confirmation action for user deletion.
   */
  public confirmDeletionClickHandler(): void {
    this.usersEc.plugins.editingPlugin.feature.actions.submit
      .from('User.Delete.Confirmation.Footer.Buttons.Confirm.Clicked')
      .dispatch({ delete: true })
  }

  /**
   * Handles the cancellation action for user deletion.
   */
  public cancelDeletionClickHandler(): void {
    this.usersEc.plugins.editingPlugin.feature.actions.discard
      .from('User.Delete.Confirmation.Footer.Buttons.Cancel.Clicked')
      .dispatch({ delete: true })
  }
}
